import { LocaleId } from '@domgen/dgx-fe-i18n';
import { AdobeRequest } from '../../models/campaign/adobe-request.interface';
import { mockCustomerDetails } from '../customer/customer-details.mock';
import { mockRegisteredItem } from '../registered-item/registered-item.mock';

export const mockAdobeRequest: AdobeRequest = {
  brand: 'WHR',
  cleartext: 'mcApi',
  email: mockCustomerDetails.email as string,
  eventType: 'wpThankYouForRegistering',
  externalId: 'loggedinuserid',
  firstName: mockCustomerDetails.firstName as string,
  language: LocaleId.English_US,
  lastName: mockCustomerDetails.lastName as string,
  modelNum: mockRegisteredItem.appliances[0].modelNumber as string,
  name: 'mcApi',
  origin: 'REGWHR',
  serialNum: mockRegisteredItem.appliances[0].serialNumber as string,
};
